module.exports = __webpack_public_path__ + "img/attendees-white.21d50dd7.svg";